<template>
  <div>
    <title>兑换礼品券基本信息</title>
    <!--S 公用头部切换-->
    <GoodsGiftInfoTab :active="currentTit"></GoodsGiftInfoTab>
    <!--E 公用头部切换-->

    <!-- S 基础详情表单组件 -->
    <GoodsInfoPage :goodsType="1"></GoodsInfoPage>
    <!-- E 基础详情表单组件 -->
    
  </div>
</template>
<script>

export default {
  name: 'goodsBasicInfo',
  data () {
    return {
      currentTit:0, //当前选中菜单
    }
  },
  filters: {

  },
  components: {
    GoodsGiftInfoTab: resolve => require(["@/components/GoodsFolder/GoodsGiftInfoTab.vue"],resolve), //头部tab组件
    GoodsInfoPage: resolve => require(["@/components/common/GoodsInfoPage.vue"],resolve), //基础详情表单组件
  },
  methods: {
    
  },
  created() {
    
  },
  mounted () {

  },
  computed: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/GoodsFolder/GoodsGift/GoodsGiftBasicInfo.vue